import React from 'react'
import { useTranslation } from 'react-i18next'
import { Cloud, CloudOff, AlertCircle } from 'lucide-react'
import { useOnlineStatus } from '../hooks/useOnlineStatus'
import { retryStuckMutation } from '../lib/syncEngine'
import { cn } from '../lib/utils'

const STUCK_THRESHOLD = 5

export default function PendingSyncBadge({ mutation, className }) {
  const { t } = useTranslation()
  const { isOnline } = useOnlineStatus()

  if (!mutation) return null

  const stuck = (mutation.attempts || 0) >= STUCK_THRESHOLD

  if (stuck) {
    return (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          retryStuckMutation(mutation.id)
        }}
        title={t('sync.stuck')}
        aria-label={t('sync.stuck')}
        className={cn(
          'inline-flex items-center text-red-500 hover:text-red-600 transition-colors',
          className
        )}
      >
        <AlertCircle className="w-3.5 h-3.5" />
      </button>
    )
  }

  if (isOnline) {
    return (
      <span
        title={t('sync.pending')}
        aria-label={t('sync.pending')}
        className={cn('inline-flex items-center text-app-primary-500 animate-pulse', className)}
      >
        <Cloud className="w-3.5 h-3.5" />
      </span>
    )
  }

  return (
    <span
      title={t('sync.pendingOffline')}
      aria-label={t('sync.pendingOffline')}
      className={cn('inline-flex items-center text-amber-500', className)}
    >
      <CloudOff className="w-3.5 h-3.5" />
    </span>
  )
}
